<template>
  <div class="parent_div">
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <section id="faq_main">
            <h2>よくある質問</h2>
            <div>
              <h3>商品に関すること</h3>
              <ul class="faq_list">
                <li>
                  <h3 v-bind:class="{Q_open: isOpenItem, Q_close: !isOpenItem}" @click="selectOpenItem()">
                    <div class="faq_btn"><span class="css-cancel3"></span></div>
                    商品仕様について
                  </h3>
                  <div v-show="isOpenItem">
                    <p>
                      商品の仕様は商品ページに記載されております。お確かめ下さい。<br>
                      <br>
                      掲載していない仕様に関しましても、ご相談承ります。 お問合わせフォームより各メーカーへご連絡ください。
                    </p>
                  </div>
                </li>
                <li>
                  <h3 v-bind:class="{Q_open: isOpenDelivery, Q_close: !isOpenDelivery}" @click="selectOpenDelivery()">
                    <div class="faq_btn"><span class="css-cancel3"></span></div>商品のお届けについて
                  </h3>
                  <div v-show="isOpenDelivery">
                    <p>
                      商品の製作にお日にちをいただいております。<br>
                      工場出荷目安は以下の通りです。<br>
                      <br>
                      ・吊戸棚（フロート収納）：10営業日～<br>
                      ・食器棚（カップボード）：16営業日<br>
                      ・玄関収納：11営業日<br>
                      ・棚板・フィラー：10営業日<br>
                      ・カウンター下収納：10営業日<br>
                      ・カウンター：15営業日<br>
                      ・サイドボード：11営業日～<br>
                      ・テレビボード：11営業日<br>
                      ※詳細なお届け日の日程はカートに追加後、購入画面より選択ください。
                    </p>
                    <!-- <ul>
                      <li>・フロート収納：10営業日～</li>
                      <li>・食器棚：16営業日</li>
                      <li>・玄関収納：11営業日</li>
                      <li>・棚板：10営業日</li>
                      <li>・カウンター下収納：10営業日</li>
                      <li>・カウンター：15営業日</li>
                      <li>・サイドボード：11営業日～</li>
                      <li>・テレビボード：11営業日</li>
                    </ul>
                    <p>※詳細なお届け日の日程はカートに追加後、購入画面より選択ください。</p> -->
                  </div>
                </li>
                <li>
                  <h3 v-bind:class="{Q_open: isOpenDeliImposible, Q_close: !isOpenDeliImposible}" @click="selectOpenDeliImposible()">
                    <div class="faq_btn"><span class="css-cancel3"></span></div>
                    納品に調整が必要な地域について
                  </h3>
                  <div v-show="isOpenDeliImposible">
                    <p>
                      恐れ入りますが、下記地域への納品は別途調整させていただきます。<br>
                      <router-link to="/mmstyle/support/input">お問合わせフォーム</router-link>よりご希望の商品と納品先のご住所をご連絡ください。
                      配送不可地域：北海道全域、沖縄全域、四国一部地域、離島など一部地域
                    </p>
                  </div>
                </li>
                <li>
                  <h3 v-bind:class="{Q_open: isOpenGuarantee, Q_close: !isOpenGuarantee}" @click="selectOpenGuarantee()">
                    <div class="faq_btn"><span class="css-cancel3"></span></div>商品の保証について
                  </h3>
                  <div v-show="isOpenGuarantee">
                    <p>
                      保証期間 対象製品の保証期間は、貴社のご指定場所に納入後1年間とします。<br>
                      <br>
                      保証内容 保証期間内に、通常使用範囲で発生した故障については無償で代替品との交換または修理をさせていただきます。 尚、取付設置時の不具合によって生じた破損につきましては、弊社では一切の責任を負いかねます。 保証期間内でも次の場合には原則「有料」にさせていただきます。<br>
                      <br>
                      ・使用 上の故意・過失または不当な修理や改造による故障及び損傷<br>
                      ・消耗部品の取替え や修理<br>
                      ・お買い上げ後の取付場所の移設、輸送、落下等による故障及び損傷<br>
                      ・火災 、地震、 水害、落雷、その他天災地変及び公害、塩害、ガス害（硫化ガス等）等による故障及び損傷<br>
                      ・車両、船舶等に搭載された場合に 生ずる故障及び損傷<br>
                      ・仕上げの傷等で、お引き渡し時に申し出がなかったもの<br>
                      ・瑕疵によら ない自然の磨耗、さび、かび、変 質、変色、その他類似の事由による場合<br>
                      ・維持管理の不備による水漏れ、膨れ、汚れ、さび、給水管、排水管の詰まり 等の不具合<br>
                      ・第三者による管理上、メンテナンス上等の不備に起因する不具合<br>
                      ・犬・猫・鳥・鼠等の小動物や虫等の行為に起因する故障及び損傷<br>
                      ・組立設置説明書に 記載された方法以外の設置内容に起因する損傷や 故障<br>
                      ・建築躯体の変形等対象商品本体以外の不具合に起因する故障及び損傷<br>
                      ・異常電圧や指定外の燃料 ・電源（電圧・周波数）の使用及び異常水質による故障及び損傷<br>
                      ・契約時、 実用化されていた技術では予防することが不可能な現象またはこれが原因で生じ た事故による場合<br>
                      ・保証期間経過後に申し出があったもの、または保証該当事項の発生後、速やか に申し出がなかったもの<br>
                      ・一般家庭用 以外（事務所、店鋪、病院等業務用 ）に 使用された場合の故障及び損傷<br>
                      ・本書のご提示がない場合<br>
                      ・家具本体にかか わるシーリング処理<br>
                      ・展示品を転売された場合<br>
                      ・保証書にお引き渡し年月日、お客様名、販売店名の記入のない場合（領収書等で左記内容がわかる場合はその限り ではありません）、 あるいは字句を書き替えられた場合<br>
                      ・離島または離島 に準じる遠隔地 へ出張修理を行う場合の出張 に要する実費<br>
                    </p>
                  </div>
                </li>
                <li>
                  <h3 v-bind:class="{Q_open: isOpenOrderCancel, Q_close: !isOpenOrderCancel}" @click="selectOpenOrderCancel()">
                    <div class="faq_btn"><span class="css-cancel3"></span></div>注文をキャンセルしたい・商品を返品したい
                  </h3>
                  <div v-show="isOpenOrderCancel">
                    <p>
                      オーダー品となる為、購入後の商品のキャンセルは承っておりません。<br>
                      お届けした商品が注文した商品と異なる場合は、お問合わせフォームよりご報告ください。
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div>
              <h3>組立設置に関すること</h3>
              <ul class="faq_list">
                <li>
                  <h3 v-bind:class="{Q_open: isOpenSetting, Q_close: !isOpenSetting}" @click="selectOpenSetting()">
                    <div class="faq_btn"><span class="css-cancel3"></span></div>設置方法について
                  </h3>
                  <div v-show="isOpenSetting">
                      <p>各シリーズの商品ページから設置説明書をダウンロードし、設置説明書に従って正しく取り付けて下さい。</p>
                  </div>
                </li>
                <li>
                  <h3 v-bind:class="{Q_open: isOpenService, Q_close: !isOpenService}" @click="selectOpenService()">
                    <div class="faq_btn"><span class="css-cancel3"></span></div>組立設置サービスについて
                  </h3>
                  <div v-show="isOpenService">
                    <p>
                      ご購入いただいた家具の組立・設置を、組立専門業者が行うサービスです。<br>
                      <br>
                      ■サービスの流れ<br>
                      <br>
                      ①ご注文の際に、組み立て作業の有無を選択いただき、作業希望日を入れていただきます。<br>
                      (作業希望日は、商品到着予定の3日以降よりご指定ください)<br>
                      ②ご注文完了後、組立業者(キャンディルグループ)より、日程調整のご連絡(メール又はお電話)をいたします。<br>
                      ③ご指定の場所にお伺いし、組立作業をいたします。<br>
                      ④作業後は周辺を清掃し、梱包材を回収します。<br>
                      ⑤作業終了後、ご確認&検収サインをいただきます。<br>
                      <br>
                      ■組立指定業者：キャンディルグループ<br>
                      <br>
                      （㈱キャンディルテクト、㈱バーンリペア)<br>
                      URL：https://www.candeal.co.jp/<br>
                      キャンディルグループでは、大手北欧家具メーカーや、国内有名メーカーなどの家具組み立てを行っております。<br>
                      経験・知識が豊富なスペシャリストが対応しますので、スピーディーな作業が可能です。安心してお任せください。<br>
                      <br>
                      ■家具組立設置サービス詳細に関するお問い合わせ<br>
                      <br>
                      ・メール … mmstyle.te@candeal.co.jp<br>
                      ・お電話 … 03-5625-3095(9:00～18:00)
                    </p>
                  </div>
                </li>
                <li>
                  <h3 v-bind:class="{Q_open: isOpenConstructPrice, Q_close: !isOpenConstructPrice}" @click="selectOpenConstructPrice()">
                    <div class="faq_btn"><span class="css-cancel3"></span></div>組立設置料金について
                  </h3>
                  <div v-show="isOpenConstructPrice">
                    <p>
                      ご購入いただいた家具に応じて組立設置料金が反映されます。<br>
                      (組立設置オプションには、以下の費用が発生します。<br>
                      組立技術料：組立作業費および副資材、簡易養生材など<br>
                      諸経費：交通費(エリアにより異なる)、燃料代など)
                    </p>
                  </div>
                </li>
                <li>
                  <h3 v-bind:class="{Q_open: isOpenConstructDate, Q_close: !isOpenConstructDate}" @click="selectOpenConstructDate()">
                    <div class="faq_btn"><span class="css-cancel3"></span></div>組立設置作業日について
                  </h3>
                  <div v-show="isOpenConstructDate">
                    <p>
                      ご注文の際に、組立設置の作業希望日をお知らせいただきます。(第3希望まで)<br>
                      ※作業希望日は、商品到着予定の、3日以降よりご指定ください。<br>
                      組立業者(キャンディルグループ)より、日程調整のご連絡(メール又はお電話)をいたします。
                    </p>
                  </div>
                </li>
                <li>
                  <h3 v-bind:class="{Q_open: isOpenConstructTime, Q_close: !isOpenConstructTime}" @click="selectOpenConstructTime()">
                    <div class="faq_btn"><span class="css-cancel3"></span></div>組立設置(訪問)の時間について
                  </h3>
                  <div v-show="isOpenConstructTime">
                    <p>訪問当日に、具体的な訪問時間をご連絡します。</p>
                  </div>
                </li>
                <li>
                  <h3 v-bind:class="{Q_open: isOpenPrecaution, Q_close: !isOpenPrecaution}" @click="selectOpenPrecaution()">
                    <div class="faq_btn"><span class="css-cancel3"></span></div>組立設置の注意事項/お願い
                  </h3>
                  <div v-show="isOpenPrecaution">
                    <p>
                      ■訪問日前までに<br>
                      <br>
                      ・作業スタッフが組み立てにお伺いする前に、お客様にて破損・不良がないかご確認をお願いいたします。<br>
                      ・スペースの確保をお願いいたします。<br>
                      ※作業を行うスペースの確保が難しい場合、予めご申告お願いいたします。<br>
                      ・家具を設置スペースに運んでいただけますと幸いです<br>
                      <br>
                      ■作業当日<br>
                      <br>
                      ・作業開始前と終了時に、作業における確認をお願いしております。ご協力のほどよろしくお願いいたします。<br>
                      ・作業により、電源をお借りする場合があります。あらかじめご了承ください。<br>
                      <br>
                      ■その他の注意事項に関しては、利用規約をご確認ください
                    </p>
                  </div>
                </li>
                <li>
                  <h3 v-bind:class="{Q_open: isOpenConsrtuctCancel, Q_close: !isOpenConsrtuctCancel}" @click="selectOpenConsrtuctCancel()">
                    <div class="faq_btn"><span class="css-cancel3"></span></div>組立設置のキャンセルについて
                  </h3>
                  <div v-show="isOpenConsrtuctCancel">
                    <p>
                      ・ご注文後のキャンセルは、お受けいたしかねます。<br>
                      (返金いたしかねますので、ご了承ください)<br>
                      ※なお、日程変更は、なるべく作業予定日の3日前までにお電話にてご連絡ください。<br>
                      <br>
                      ■家具組立設置サービス詳細に関するお問い合わせ<br>
                      <br>
                      キャンディルグループ<br>
                      メール … mmstyle.te@candeal.co.jp<br>
                      お電話 … 03-5625-3095 (9:00～18:00)
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div>
              <h3>mm/styleの操作に関すること</h3>
              <ul class="faq_list">
                <li>
                  <h3 v-bind:class="{Q_open: isOpenUserUpdate, Q_close: !isOpenUserUpdate}" @click="selectOpenUserUpdate()">
                    <div class="faq_btn"><span class="css-cancel3"></span></div>会員情報を変更したい
                  </h3>
                  <div v-show="isOpenUserUpdate">
                    <p>登録情報確認ページより編集することができます。</p>
                  </div>
                </li>
                <li>
                  <h3 v-bind:class="{Q_open: isOpenOther, Q_close: !isOpenOther}" @click="selectOpenOther()">
                    <div class="faq_btn"><span class="css-cancel3"></span></div>そのほかのお問い合わせ
                  </h3>
                  <div v-show="isOpenOther">
                    <p>ご不明なことがございましたら、<router-link to="/mmstyle/support/input">お問合わせフォーム</router-link>よりご連絡ください。</p>
                  </div>
                </li>
                <li>
                  <h3 v-bind:class="{Q_open: isOpenPayment, Q_close: !isOpenPayment}" @click="selectOpenPayment()">
                    <div class="faq_btn"><span class="css-cancel3"></span></div>購入の流れ・決済について
                  </h3>
                  <div v-show="isOpenPayment">
                    <p>
                      お支払い方法は複数あります。<br>
                      ご注文が完了したあとはお支払い方法の変更はできません。<br>
                      <br>
                      ※ 個人のお客様がご利用いただける支払い方法は「クレジットカード」、「銀行振込」となります。<br>
                      <span v-if="isCorpLogin">※ 法人のお客様は、「<span class="link" @click="deferPayment">後払いサービス</span>」をご利用いただけます。 ＊申込みと審査が必要となります。</span>
                    </p>
                  </div>
                </li>
                <li>
                  <h3 v-bind:class="{Q_open: isOpenWithDrawl, Q_close: !isOpenWithDrawl}" @click="selectOpenWithDrawl()">
                    <div class="faq_btn"><span class="css-cancel3"></span></div>退会したい
                  </h3>
                  <div v-show="isOpenWithDrawl">
                    <p>お問い合わせフォームよりご連絡ください。</p>
                  </div>
                </li>
                <li v-if="false">
                  <h3 v-bind:class="{Q_open: isReceipt, Q_close: !isReceipt}" @click="selectReceipt()">
                    <div class="faq_btn"><span class="css-cancel3"></span></div>領収書について
                  </h3>
                  <div v-show="isReceipt">
                    <p>
                      →問い合わせフォームから依頼<br>
                      ・お支払い・送料について<br>
                      →決済手段、送料は商品カスタマイズ画面で仕様に応じて算出される仕組み
                    </p>
                  </div>
                </li>
                <li v-if="false">
                  <h3 v-bind:class="{Q_open: isPaymentDelivery, Q_close: !isPaymentDelivery}" @click="selectPaymentDelivery()">
                    <div class="faq_btn"><span class="css-cancel3"></span></div>お支払い・送料について
                  </h3>
                  <div v-show="isPaymentDelivery">
                    <p>→決済手段、送料は商品カスタマイズ画面で仕様に応じて算出される仕組み</p>
                  </div>
                </li>
              </ul>
            </div>
          </section>
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import * as App from '../../utils/App'
import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'

export default {
  name: 'faq',
  components: {
    'dd-header': DcHeader,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': DcSiteMap
  },
  data () {
    return {
      pageKey: 'dcFaq',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'faq', key: 'dcFaq', title: 'よくある質問', route: 'Faq'}
      ],
      isOpenItem: false,
      isOpenFiller: false,
      isOpenDelivery: false,
      isOpenDeliImposible: false,
      isOpenPayment: false,
      isOpenTransition: false,
      isOpenSetting: false,
      isOpenGuarantee: false,
      isOpenCancel: false,
      isOpenConstruct: false,
      isOpenUserUpdate: false,
      isOpenWithDrawl: false,
      isOpenOther: false,
      isOpenService: false,
      isOpenConstructPrice: false,
      isOpenConstructDate: false,
      isOpenConstructTime: false,
      isOpenPrecaution: false,
      isOpenOrderCancel: false,
      isOpenConsrtuctCancel: false,
      isReceipt: false,
      isPaymentDelivery: false
    }
  },
  methods: {
    selectOpenItem: function () {
      this.isOpenItem = !this.isOpenItem
    },
    selectOpenFiller: function () {
      this.isOpenFiller = !this.isOpenFiller
    },
    selectOpenDelivery: function () {
      this.isOpenDelivery = !this.isOpenDelivery
    },
    selectOpenDeliImposible: function () {
      this.isOpenDeliImposible = !this.isOpenDeliImposible
    },
    selectOpenPayment: function () {
      this.isOpenPayment = !this.isOpenPayment
    },
    selectOpenTransition: function () {
      this.isOpenTransition = !this.isOpenTransition
    },
    selectOpenSetting: function () {
      this.isOpenSetting = !this.isOpenSetting
    },
    selectOpenGuarantee: function () {
      this.isOpenGuarantee = !this.isOpenGuarantee
    },
    selectOpenCancel: function () {
      this.isOpenCancel = !this.isOpenCancel
    },
    selectOpenConstruct: function () {
      this.isOpenConstruct = !this.isOpenConstruct
    },
    selectOpenUserUpdate: function () {
      this.isOpenUserUpdate = !this.isOpenUserUpdate
    },
    selectOpenWithDrawl: function () {
      this.isOpenWithDrawl = !this.isOpenWithDrawl
    },
    selectOpenOther: function () {
      this.isOpenOther = !this.isOpenOther
    },
    selectOpenService: function () {
      this.isOpenService = !this.isOpenService
    },
    selectOpenConstructPrice: function () {
      this.isOpenConstructPrice = !this.isOpenConstructPrice
    },
    selectOpenConstructDate: function () {
      this.isOpenConstructDate = !this.isOpenConstructDate
    },
    selectOpenConstructTime: function () {
      this.isOpenConstructTime = !this.isOpenConstructTime
    },
    selectOpenPrecaution: function () {
      this.isOpenPrecaution = !this.isOpenPrecaution
    },
    selectOpenOrderCancel: function () {
      this.isOpenOrderCancel = !this.isOpenOrderCancel
    },
    selectOpenConsrtuctCancel: function () {
      this.isOpenConsrtuctCancel = !this.isOpenConsrtuctCancel
    },
    selectReceipt: function () {
      this.isReceipt = !this.isReceipt
    },
    selectPaymentDelivery: function () {
      this.isPaymentDelivery = !this.isPaymentDelivery
    },
    closeMenu: function () {
      this.$refs.menuRef.close()
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    deferPayment: function () {
      this.$router.push({
        name: 'DcPaymentService'
      })
    }
  },
  mounted () {
  }
}
</script>
<style src="../css/dc-mainmenu.scss" lang="scss" scoped></style>
<style src="../css/dctop4.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcFaq.vue